/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSpace} from '../api'

 export const useQueryGetSpace = createReactQueryHook('getSpace', getSpace)
